var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-item-wrapper', {
    attrs: {
      "designer": _vm.designer,
      "field": _vm.field,
      "rules": _vm.rules,
      "design-state": _vm.designState,
      "parent-widget": _vm.parentWidget,
      "parent-list": _vm.parentList,
      "index-of-parent-list": _vm.indexOfParentList,
      "sub-form-row-index": _vm.subFormRowIndex,
      "sub-form-col-index": _vm.subFormColIndex,
      "sub-form-row-id": _vm.subFormRowId
    }
  }, [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadMode),
      expression: "!isReadMode"
    }],
    ref: "fieldEditor",
    staticClass: "hide-spin-button",
    attrs: {
      "disabled": _vm.field.options.disabled,
      "readonly": _vm.field.options.readonly,
      "type": _vm.inputType,
      "show-password": _vm.field.options.showPassword,
      "placeholder": _vm.field.options.placeholder,
      "clearable": _vm.field.options.clearable,
      "minlength": _vm.field.options.minLength,
      "maxlength": _vm.field.options.maxLength,
      "show-word-limit": _vm.field.options.showWordLimit,
      "prefix-icon": _vm.field.options.prefixIcon,
      "suffix-icon": _vm.field.options.suffixIcon
    },
    on: {
      "focus": _vm.handleFocusCustomEvent,
      "blur": _vm.handleBlurCustomEvent,
      "input": _vm.handleInputCustomEvent,
      "change": _vm.handleChangeEvent
    },
    model: {
      value: (_vm.fieldModel),
      callback: function($$v) {
        _vm.fieldModel = $$v
      },
      expression: "fieldModel"
    }
  }, [(_vm.field.options.appendButton) ? _c('el-button', {
    class: _vm.field.options.buttonIcon,
    attrs: {
      "slot": "append",
      "disabled": _vm.field.options.disabled || _vm.field.options.appendButtonDisabled
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitAppendButtonClick.apply(null, arguments)
      }
    },
    slot: "append"
  }) : _vm._e()], 1), _vm._v(" "), (_vm.isReadMode) ? [_c('span', {
    staticClass: "readonly-mode-field"
  }, [_vm._v(_vm._s(_vm.fieldModel))])] : _vm._e()], 2)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52dcca65","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/form-widget/field-widget/input-widget.vue
// module id = null
// module chunks = 